/**
 * @fileoverview JsonFormsLayout component for the Storyteller web application.
 * Renders a layout container for JSON Forms.
 *
 * @example
 * // Basic usage
 * <JsonFormsLayout className="layout-class" visible={true}>
 *   <div>Child component</div>
 * </JsonFormsLayout>
 */

import { RendererProps } from '@jsonforms/core'
import { VanillaRendererProps, WithChildren } from '@jsonforms/vanilla-renderers'

/**
 * @function JsonFormsLayout
 * @description Component for rendering a layout container for JSON Forms.
 * @param {RendererProps & VanillaRendererProps & WithChildren} props - The props for the JsonFormsLayout component.
 * @returns {JSX.Element} The JsonFormsLayout component.
 */
export const JsonFormsLayout = ({
    className,
    children,
    visible,
}: RendererProps & VanillaRendererProps & WithChildren) => {
    return (
        <div
            className={className}
            hidden={visible === undefined || visible === null ? false : !visible}
        >
            {children}
        </div>
    )
}
